var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08322 3.49935V1.74935C4.08322 1.42719 4.34439 1.16602 4.66655 1.16602H11.6666C11.9887 1.16602 12.2499 1.42719 12.2499 1.74935V9.91602C12.2499 10.2382 11.9887 10.4993 11.6666 10.4993H9.91655V12.2488C9.91655 12.5713 9.65411 12.8327 9.32925 12.8327H2.33722C2.01284 12.8327 1.75 12.5733 1.75 12.2488L1.75152 4.08319C1.75157 3.76075 2.01404 3.49935 2.33883 3.49935H4.08322ZM2.91808 4.66602L2.91678 11.666H8.74988V4.66602H2.91808ZM5.24988 3.49935H9.91655V9.33268H11.0832V2.33268H5.24988V3.49935Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f197aa4f8ff8d635fcfcb48a9f8edbc8.svg";
export { ForwardRef as ReactComponent };